import React from "react";
import CourtBar from "./components/CourtBar";
import CourtGridTable from "./components/CourtGridTable";
import CourtReservationModal from "./components/CourtReservationModal";
import EASkeletonLoader from "../shared/EASkeletonLoader";
import useCourtGrid from "./useCourtGrid";
import { SaleStep } from "../../store/stepSaleConfig/stepSaleConfigReducer";
import EAAlert from "../shared/EAAlert";

interface IProps {
  saleStep: SaleStep;
}

const CourtGrid: React.FC<IProps> = ({ saleStep }) => {
  const {
    courtGridData,
    loading: dataLoading,
    selectedDate,
    selectedCourts,
    setSelectedDate,
    setSelectedCourts,
    updateCourtFilters,
    persistentSelectedCourts,
    showPastHours,
    setShowPastHours,
    currentCourtIndex,
    reservationModal,
    displayedCourts,
    filteredCourts,
    uniqueHours,
    findSlot,
    getSlotStatus,
    visibleHours,
    hasPastHours,
    refetchCourtData,
    handleSlotClick,
    handleCloseReservationModal,
    handlePreviousCourt,
    handleNextCourt,
    handleSetCourtIndex,
    handleTicketAdded,
  } = useCourtGrid(saleStep.exerciseName);

  const availableCourts = courtGridData?.courts || [];

  if (dataLoading && !courtGridData) {
    return <EASkeletonLoader height="400px" />;
  }

  return (
    <div className="court-grid-container">
      <CourtBar
        selectedDate={selectedDate}
        setSelectedDate={setSelectedDate}
        availableCourts={availableCourts}
        selectedCourts={selectedCourts}
        setSelectedCourts={setSelectedCourts}
        updateCourtFilters={updateCourtFilters}
        persistentSelectedCourts={persistentSelectedCourts}
        exerciseName={saleStep.exerciseName}
      />

      {dataLoading ? (
        <EASkeletonLoader height="400px" />
      ) : !courtGridData ? (
        <EAAlert type="error" message="Nie udało się załadować danych kortów." />
      ) : (
        <CourtGridTable
          displayedCourts={displayedCourts}
          filteredCourts={filteredCourts}
          visibleHours={visibleHours(uniqueHours, showPastHours)}
          hasPastHours={hasPastHours(uniqueHours) && !showPastHours}
          findSlot={findSlot}
          getSlotStatus={getSlotStatus}
          onSlotClick={handleSlotClick}
          onShowPastHours={() => setShowPastHours(true)}
          onCourtSelect={handleSetCourtIndex}
          onPreviousCourt={handlePreviousCourt}
          onNextCourt={handleNextCourt}
          currentCourtIndex={currentCourtIndex}
          filteredCourtsLength={filteredCourts.length}
          saleStep={saleStep}
        />
      )}

      <CourtReservationModal
        isOpen={reservationModal.isOpen}
        onClose={handleCloseReservationModal}
        exerciseId={reservationModal.exerciseId}
        saleStep={saleStep}
        onTicketAdded={handleTicketAdded}
        onDataRefresh={refetchCourtData}
      />
    </div>
  );
};

export default CourtGrid;
